/**
 * Ensure something is an array or in an array, if value is null/undefined then empty array is returned
 * @param {Object[]} value
 * @return {Object[]} returns an empty arror if value is NULL or undefined ELSE if value is array then value is returned
 */
function ensureArray (value: any) {
  if ([null, undefined].includes(value)) {
    return []
  } else {
    if (Array.isArray(value)) {
      return value
    } else {
      return [value]
    }
  }
}

export { ensureArray }
